<template>
<div id="title" v-bind:style="bgcolors.header">
	<div id="title_wrap">
		<div class="hplink"><a href="http://www.jikkyo.co.jp/" target="_blank" rel="noopener">実教出版</a></div>
		<div id="wrap">
			<!-- ドリルが1タイトルの場合はこちらを使用 -->
			
			<div class="cover1" >
				<img src="@/assets/img/cover/cover_23sei1.jpg" alt="">
			</div>
			<!-- ドリルが2タイトルの場合はこちらを使用 -->
			<!--<div class="cover2">
				<img src="@/assets/img/cover/cover1.png" alt="">
				<img src="@/assets/img/cover/cover2.png" alt="">
			</div>-->
			<div class="drill_title">
				<!--<h1><img alt="アプリタイトル" src="@/assets/img/title/title.png"></h1>-->
				<h1 v-html="drill_title"></h1><!-- title_htmlでタイトルをhtmlタグで表示する場合はこちらを使用 -->
			</div>
			<div class="img_chr"><img src="@/assets/img/pgn04.png" alt="ペンギン"></div>
		</div>
	</div>
</div>
</template>

<script>
import getSettingtext from "@/assets/settings.json"

export default {
	name: 'drill_title',
	props: {
		drill_title: String
	},
	data: function() {
		return {
			bgcolors: {
				header: {background: getSettingtext.bgcolors.header},
			},
		}
	},
}
</script>

<style scoped src="../assets/css/drill_title.css"></style>